import { get, getDatabase, push, ref, set } from 'firebase/database';
import { initFb } from './config';
import {
  getDownloadURL,
  getStorage,
  ref as sRef,
  uploadBytes,
} from 'firebase/storage';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import html2pdf from 'html2pdf.js';
// const { initializeApp } = window.FirebaseApp,
//   { getDatabase, ref, push, set, get } = window.FirebaseDatabase,
//   {
//     getStorage,
//     ref: sRef,
//     uploadBytes,
//     getDownloadURL,
//   } = window.FirebaseStorage;
let databaseInstance = null,
  storageInstance = null,
  currentVoucherId = null,
  isRecipientMode = !1,
  auth = null,
  adminId = null;
let activeLs = [];
// const FIREBASE_HARDCODED_CONFIG = {
//   apiKey: 'YOUR_API_KEY_HERE',
//   databaseURL: 'https://YOUR_DATABASE_://firebaseio.com',
//   projectId: 'YOUR_PROJECT_ID_HERE',
//   storageBucket: 'YOUR_STORAGE_BUCKET_://appspot.com',
// };
document.addEventListener('DOMContentLoaded', () => {
  initializeFirebasePipeline();
  document
    .getElementById('upload-btn')
    .addEventListener('click', executeDatabaseAndCloudUpload);
  document
    .getElementById('print-local-btn')
    .addEventListener('click', () => window.print());
  document
    .getElementById('reset-btn')
    .addEventListener('click', resetFormWorkspace);
  initializeSignaturePad('canvas-landlord', 'clear-landlord', '#0f2d59');
  initializeSignaturePad('canvas-officer', 'clear-officer', '#b45309');
});
function setDefaultSystemDates() {
  const today = new Date().toISOString().split('T');
  document.getElementById('voucher-date').value = today[0];
  document.getElementById('sig-date').value = today[0];
}
// Add these updates to the top of your existing compressed sign.js file
async function initializeFirebasePipeline() {
  try {
    initFb();
    adminId = await getCurrentUserId();

    databaseInstance = getDatabase();
    const dbAdmin = ref(databaseInstance, `admin/${adminId}`);
    const dbAdminSnapshot = await get(dbAdmin);
    let isAdmin = dbAdminSnapshot.exists() && dbAdminSnapshot.val() === true;
    storageInstance = getStorage();
    setDefaultSystemDates();

    const urlParams = new URLSearchParams(window.location.search);
    const signatureToken = urlParams.get('token');
    const incomingCaseId = urlParams.get('caseId'); // NEW: Captures parent case ID from portal.html

    if (signatureToken || !isAdmin) {
      isRecipientMode = !0;
      await loadRecipientSigningInterface(signatureToken);
    } else {
      generateAndSetNewVoucherId();

      // NEW: If launched from a case row, bind the case tracking property to the form state
      if (incomingCaseId) {
        console.log(
          'Voucher securely attached to parent case workspace: ' +
            incomingCaseId,
        );
        // Optional: Store this variable globally inside your form payload object
        window.activeParentCaseId = incomingCaseId;
      }
    }
  } catch (t) {
    alert('Init Fail: ' + t.message);
  }
}

function getCurrentUserId() {
  return new Promise((resolve, reject) => {
    auth = getAuth();
    let unsub = onAuthStateChanged(auth, (user) => {
      unsub();
      if (user) {
        adminId = user.uid;
        resolve(adminId);
      } else {
        reject(new Error('No user signed in.'));
      }
    });
  });
}

async function loadRecipientSigningInterface(t) {
  const e = document.getElementById('status-display');
  e.innerText = 'Status: Validating token...';
  try {
    const a = await get(ref(databaseInstance, `signatureTokens/${t}`));
    if (!a.exists())
      return (alert('Invalid Link'), void (e.innerText = 'ERROR: Denied.'));
    const n = a.val();
    currentVoucherId = n.voucherId;
    document.getElementById('data-voucherNum').value = currentVoucherId;
    const d = await get(ref(databaseInstance, `DISB/${currentVoucherId}`));
    if (!d.exists()) return void alert('Record missing.');
    const r = d.val();
    document.getElementById('data-orgName').value = r.organization.name;
    document.getElementById('data-ein').value = r.organization.ein;
    document.getElementById('data-orgEmail').value = r.organization.email;
    document.getElementById('data-wireRef').value = r.metadata.wireReference;
    document.getElementById('data-recipName').value = r.recipient.name;
    document.getElementById('data-recipId').value = r.recipient.idNumber;
    document.getElementById('data-recipBank').value = r.recipient.bank;
    document.getElementById('data-benefName').value = r.beneficiary.name;
    document.getElementById('data-address').value = r.beneficiary.location;
    document.getElementById('data-category').value = r.beneficiary.aidCategory;
    document.getElementById('data-description').value =
      r.financials.allocationDescription;
    document.getElementById('data-amtUsd').value = r.financials.usdAmount;
    document.getElementById('data-currencyCode').value =
      r.financials.localCurrencyCode;
    document.getElementById('data-amtLocal').value =
      r.financials.localConvertedAmount;
    document.querySelectorAll('input,select').forEach((t) => {
      'sig-date' !== t.id &&
        (t.setAttribute('disabled', 'true'),
        (t.style.backgroundColor = '#f8fafc'));
    });
    document.getElementById('officer-sig-box').style.display = 'none';
    document.getElementById('attachment-container').style.display = 'none';
    document.getElementById('reset-btn').style.display = 'none';
    const o = document.getElementById('upload-btn');
    o.innerText = 'Submit Signature';
    o.removeAttribute('disabled');
    e.style.color = '#16a34a';
    e.innerText = 'Ready to sign.';
  } catch (t) {
    alert('Err: ' + t.message);
  }
}
function generateAndSetNewVoucherId() {
  if (!databaseInstance) return;
  const t = push(ref(databaseInstance, 'DISB')).key;
  currentVoucherId = t;
  document.getElementById('data-voucherNum').value = t;
  document.getElementById('status-display').innerText =
    'Status: ID ' + t + ' allocated.';
}
function initializeSignaturePad(t, e, a) {
  const n = document.getElementById(t),
    d = n.getContext('2d'),
    r = document.getElementById(e);
  function o() {
    const t = n.getBoundingClientRect();
    n.width = t.width;
    n.height = t.height;
    d.strokeStyle = a;
    d.lineWidth = 2;
    d.lineCap = 'round';
  }
  window.addEventListener('resize', o);
  setTimeout(o, 400);
  let c = !1;
  const i = (t) => {
    const e = n.getBoundingClientRect();
    return {
      x: (t.touches ? t.touches.clientX : t.clientX) - e.left,
      y: (t.touches ? t.touches.clientY : t.clientY) - e.top,
    };
  };
  const s = (t) => {
    c = !0;
    const e = i(t);
    d.beginPath();
    d.moveTo(e.x, e.y);
    t.preventDefault();
  };
  const m = (t) => {
    if (c) {
      const e = i(t);
      d.lineTo(e.x, e.y);
      d.stroke();
    }
    t.preventDefault();
  };
  n.addEventListener('mousedown', s);
  n.addEventListener('mousemove', m);
  window.addEventListener('mouseup', () => (c = !1));
  n.addEventListener('touchstart', s, { passive: !1 });
  n.addEventListener('touchmove', m, { passive: !1 });
  window.addEventListener('touchend', () => (c = !1));
  r.addEventListener('click', () => d.clearRect(0, 0, n.width, n.height));
}
async function executeDatabaseAndCloudUpload() {
  if (!databaseInstance || !storageInstance) return;
  if (!isRecipientMode) {
    document
      .querySelectorAll('input,select')
      .forEach((t) => (t.style.borderColor = ''));
    const t = [
      'data-wireRef',
      'data-recipName',
      'data-recipId',
      'data-recipBank',
      'data-benefName',
      'data-address',
      'data-category',
      'data-description',
      'data-amtUsd',
    ];
    let e = 0;
    if (
      (t.forEach((t) => {
        const a = document.getElementById(t);
        (a && a.value.trim()) || ((a.style.borderColor = '#ef4444'), e++);
      }),
      e > 0)
    )
      return void alert('Error: Required fields are missing.');
  }
  const statusDisplay = document.getElementById('status-display');
  statusDisplay.innerText = 'Status: Exporting payload...';
  const payload = {
    voucherId: currentVoucherId,
    adminId: adminId,
    caseId: window.activeParentCaseId || 'N/A',
    voucherDate: document.getElementById('voucher-date').value,
    wireRef: document.getElementById('data-wireRef').value,
    signDate: document.getElementById('sig-date').value,
    payeeName: document.getElementById('data-recipName').value,
    payeeId: document.getElementById('data-recipId').value,
    payeeBank: document.getElementById('data-recipBank').value,
    doneeName: document.getElementById('data-recipName').value,
    doneeAddress: document.getElementById('data-address').value,
    program: document.getElementById('data-category').value,
    purpose: document.getElementById('data-description').value,
    usdAmount: document.getElementById('data-amtUsd').value,
    localCurrency: (
      document.getElementById('data-currencyCode').value || ''
    ).toUpperCase(),
    localAmount: document.getElementById('data-amtLocal').value,
    date: new Date().getTime(),
    timestamp: new Date().toISOString(),
  };
  try {
    await set(ref(databaseInstance, `DISB/${currentVoucherId}`), payload);
    statusDisplay.innerText = 'Status: Compiling PDF...';

    const a = await html2pdf()
      .set({
        margin: 0.2,
        filename: currentVoucherId + '_Voucher.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, useCORS: !0 },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
      })
      .from(document.getElementById('invoice-render-target'))
      .output('blob');
    statusDisplay.innerText = 'Status: Uploading PDF...';
    const n = sRef(
      storageInstance,
      `DISBFiles/${currentVoucherId}/${currentVoucherId}_Voucher.pdf`,
    );
    await uploadBytes(n, a);
    const url = await getDownloadURL(n);
    await set(
      push(ref(databaseInstance, `disbFiles/${currentVoucherId}`)),
      url,
    );
    if (!isRecipientMode) {
      const inAddionalFiles = document.getElementById('additional-files-input');
      if (inAddionalFiles.files.length > 0)
        for (let e = 0; e < inAddionalFiles.files.length; e++) {
          const a = sRef(
            storageInstance,
            `DISBFiles/${currentVoucherId}/attachments/${Date.now()}_${inAddionalFiles.files[e].name}`,
          );
          await uploadBytes(a, inAddionalFiles.files[e]);
          const n = await getDownloadURL(a);
          await set(
            push(ref(databaseInstance, `disbFiles/${currentVoucherId}`)),
            n,
          );
        }
    }
    lockDownVoucherInterface();
    statusDisplay.style.color = '#16a34a';
    statusDisplay.innerText = 'SUCCESS: Locked.';
    alert('Sync complete.');
  } catch (e) {
    statusDisplay.style.color = '#dc2626';
    statusDisplay.innerText = 'ERROR: ' + e.message;
  }
}
function lockDownVoucherInterface() {
  document.querySelectorAll('input,select').forEach((t) => {
    t.setAttribute('disabled', 'true');
    t.style.backgroundColor = '#e2e8f0';
  });
  document.getElementById('upload-btn').setAttribute('disabled', 'true');
  document.getElementById('upload-btn').style.backgroundColor = '#64748b';
  document.getElementById('clear-landlord').style.display = 'none';
  document.getElementById('clear-officer').style.display = 'none';
  const t = document.getElementById('attachment-container');
  t && (t.style.opacity = '0.5');
}
function resetFormWorkspace() {
  if (!confirm('Clear form?')) return;
  document.querySelectorAll('input,select').forEach((t) => {
    ('data-orgName' !== t.id &&
      'data-ein' !== t.id &&
      'data-orgEmail' !== t.id &&
      (t.value = ''),
      t.removeAttribute('disabled'),
      (t.style.backgroundColor = '#fff'),
      (t.style.borderColor = ''));
  });
  document.getElementById('upload-btn').removeAttribute('disabled');
  document.getElementById('upload-btn').style.backgroundColor = '#0f2d59';
  document.getElementById('clear-landlord').style.display = 'block';
  document.getElementById('clear-officer').style.display = 'block';
  document.getElementById('attachment-container').style.opacity = '1';
  document.getElementById('status-display').style.color = '#1e40af';
  ['canvas-landlord', 'canvas-officer'].forEach((t) => {
    const e = document.getElementById(t);
    e.getContext('2d').clearRect(0, 0, e.width, e.height);
  });
  setDefaultSystemDates();
  generateAndSetNewVoucherId();
}
